export class QueryDeleteModel {
    QueryCode: number = 0;
    QueryDetailCode: number = 0;
    Comment: string = '';
    IsDeletedByPartner: boolean = false;
    DeletedBy: number = 0;
}
